<script lang="ts" setup>
defineProps({
  title: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <div>
    <div class="flex items-start q-gutter-x-md q-pb-sm no-wrap">
      <slot name="title">
        <div class="title">
          {{ title }}
        </div>
      </slot>

      <slot name="left" />

      <q-space />

      <slot name="right" />
    </div>

    <div v-if="$slots.bottom" class="full-width">
      <slot name="bottom" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.title {
  font-size: 18px;
  font-weight: 600;
}
</style>
